import { materials } from '@/mocks/homeData';

const iconTone: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-700',
  secondary: 'bg-secondary-100 text-secondary-900',
};

const typeTone: Record<string, string> = {
  图片模板: 'bg-accent-100 text-accent-700',
  文案文本: 'bg-primary-100 text-primary-700',
  音频歌单: 'bg-secondary-100 text-secondary-900',
  参考文档: 'bg-background-200 text-foreground-700',
  图片整包: 'bg-accent-100 text-accent-700',
  预设文件: 'bg-background-200 text-foreground-700',
};

export default function Materials() {
  return (
    <section id="materials" className="w-full bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-accent-500">
            <i className="ri-folder-download-fill" /> 素材库
          </span>
          <h2 className="mt-2 text-2xl font-extrabold text-foreground-950 md:text-4xl">
            91免费素材库 · 常用素材整包
          </h2>
          <p className="mt-3 text-sm text-foreground-600 md:text-base">
            91免费素材库把常用图片、文案、音频与预设按用途整理成包，标注大小与热度，商用前记得核对授权。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {materials.map((mat) => (
            <div
              key={mat.name}
              className="flex items-center gap-4 rounded-2xl border border-background-200 bg-background-100 p-5 transition-colors hover:border-accent-300"
            >
              <span
                className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-xl text-xl ${iconTone[mat.tone]}`}
              >
                <i className={mat.icon} />
              </span>
              <div className="min-w-0 flex-1">
                <h3 className="truncate text-sm font-bold text-foreground-950 md:text-base">{mat.name}</h3>
                <div className="mt-1.5 flex flex-wrap items-center gap-2 text-xs text-foreground-500">
                  <span
                    className={`whitespace-nowrap rounded px-1.5 py-0.5 text-[11px] font-medium ${typeTone[mat.type]}`}
                  >
                    {mat.type}
                  </span>
                  <span>{mat.size}</span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-download-2-line" /> {mat.count}
                  </span>
                </div>
              </div>
              <a
                href="#top"
                aria-label={`进入${mat.name}`}
                className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-secondary-500 text-background-50 transition-colors hover:bg-secondary-600"
              >
                <i className="ri-arrow-right-line" />
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}